// extracted by mini-css-extract-plugin
module.exports = {"tokenTitle":"token-column_tokenTitle__2Jqj-","line":"token-column_line__2TrFN"};